import React from "react";
import { Box, Typography, Modal, Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DescriptionIcon from "@mui/icons-material/Description";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import "./AddUserComponent.css";

const AddBPUserComponent = ({
  singleUser,
  setSingleUser,
  handleCreateNewUser,
  openBulkModal,
  setOpenBulkModal,
  handleBulkFileUpload,
  parsedBulkUsers,
  handleBulkAddUser,
  bulkFile,
  downloadCSVTemplate,
  setParsedBulkUsers,
  setBulkFile
}) => {
  const navigate = useNavigate();

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const file = e.dataTransfer.files[0];
    if (file && (file.type === "text/csv" || file.name.endsWith(".csv"))) {
      handleBulkFileUpload(file);
    } else {
      alert("Please upload a CSV file");
    }
  };

  const handleFileInput = (e) => {
    const file = e.target.files[0];
    if (file && (file.type === "text/csv" || file.name.endsWith(".csv"))) {
      handleBulkFileUpload(file);
    } else {
      alert("Please upload a CSV file");
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleCreateNewUser();
  };

  return (
    <Box className="bp-user-management-container">
      <Sidebar />
      <Box className="add-user-main-content">
        <div className="add-user-header">
          <span className="back-arrow" onClick={() => navigate(-1)}>←</span>
          <h2 className="add-user-title">Add User</h2>
          <button className="bulk-user-button" onClick={() => setOpenBulkModal(true)}>
            + Add Bulk User
          </button>
        </div>

        <div className="add-user-form-box">
          <form className="add-user-form" onSubmit={handleFormSubmit}>
            <div className="form-group">
              <label>Organization ID<span className="required">*</span></label>
              <input
                type="text"
                value={singleUser.orgId}
                onChange={(e) => setSingleUser({ ...singleUser, orgId: e.target.value })}
                placeholder="Enter The Organization ID"
                required
              />
            </div>

            <div className="form-group">
              <label>Department Name<span className="required">*</span></label>
              <input
                type="text"
                value={singleUser.department}
                onChange={(e) => setSingleUser({ ...singleUser, department: e.target.value })}
                placeholder="Enter The Department Name"
                required
              />
            </div>

            <div className="form-group">
              <label>Name<span className="required">*</span></label>
              <input
                type="text"
                value={singleUser.userName}
                onChange={(e) => setSingleUser({ ...singleUser, userName: e.target.value })}
                placeholder="Enter The Name Of User"
                required
              />
            </div>

            <div className="form-group">
              <label>Business ID (Email)<span className="required">*</span></label>
              <input
                type="email"
                value={singleUser.businessId}
                onChange={(e) => setSingleUser({ ...singleUser, businessId: e.target.value })}
                placeholder="Enter The Email ID Of The User"
                required
              />
            </div>

            <button type="submit" className="submit-button">
              Add User
            </button>
          </form>
        </div>
      </Box>

      <Modal open={openBulkModal} onClose={() => setOpenBulkModal(false)}>
        <Box className="bulk-upload-modal">
          <p align="center">
            Add Users in Bulk?{" "}
            <span
              style={{ color: "#0560BC", cursor: "pointer", textDecoration: "underline" }}
              onClick={downloadCSVTemplate}
            >
              Download Format
            </span>
          </p>

          {/* Show Drop Zone only if bulkFile is not present */}
          {!bulkFile && (
            <Box className="drop-zone" onDragOver={handleDragOver} onDrop={handleDrop}>
              <CloudUploadIcon fontSize="large" />
              <Typography className="drop-text">
                <span className="choose-file">Choose file</span> or drag here
              </Typography>
              <input
                type="file"
                accept=".csv"
                onChange={handleFileInput}
                className="file-input"
                id="csv-upload"
              />
            </Box>
          )}

          {/* If CSV file is uploaded, show preview */}
          {bulkFile && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#f4f4f4",
                borderRadius: "10px",
                padding: "12px 16px",
                marginTop: "20px",
                boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <DescriptionIcon sx={{ color: "#14AE78", fontSize: "32px" }} />
                <Box>
                  <Typography fontWeight={600}>{bulkFile.name}</Typography>
                  <Typography sx={{ fontSize: "13px", color: "#555" }}>
                    {(bulkFile.size / (1024 * 1024)).toFixed(1)} MB
                  </Typography>
                </Box>
              </Box>

              <Button
                variant="outlined"
                color="error"
                size="small"
                onClick={() => {
                  setBulkFile(null);
                  setParsedBulkUsers([]);
                }}
              >
                Remove
              </Button>
            </Box>
          )}

         
          {parsedBulkUsers.length > 0 && (
            <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
              <Button variant="outlined" onClick={() => setOpenBulkModal(false)}>
                Cancel
              </Button>
              <Button variant="contained" color="success" onClick={handleBulkAddUser}>
                Submit
              </Button>
            </Box>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default AddBPUserComponent;
